/* Desi Store PDP — behaviour for ds-* sections. Safe to load multiple times. */
(function () {
  if (window.__dsPdpInit) { document.dispatchEvent(new Event('ds:refresh')); return; }
  window.__dsPdpInit = true;

  var easeOutExpo = function (p) { return p === 1 ? 1 : 1 - Math.pow(2, -10 * p); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function animateNumber(el, from, to, ms, locale, done) {
    var t0 = performance.now();
    function f(t) {
      var p = Math.min(1, (t - t0) / ms);
      el.textContent = Math.floor(from + easeOutExpo(p) * (to - from)).toLocaleString(locale);
      if (p < 1) requestAnimationFrame(f); else if (done) done();
    }
    requestAnimationFrame(f);
  }

  /* Gallery */
  function initGallery(root) {
    if (root.__ds) return; root.__ds = 1;
    var track = root.querySelector('[data-ds-gal-track]');
    var count = root.querySelector('[data-ds-gal-count]');
    var thumbs = $$('[data-ds-thumb]', root.closest('[data-ds-hero]') || root);
    var slides = $$('.ds-gal__slide', track);
    var total = slides.length, current = -1;
    function step() { var c = slides[0]; return c ? c.offsetWidth + 8 : 300; }
    function setActive(i) {
      if (i === current) return; current = i;
      if (count) count.textContent = (i + 1) + ' / ' + total;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      slides.forEach(function (s, k) {
        var v = s.querySelector('video'); if (!v) return;
        if (k === i) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
      });
    }
    track.addEventListener('scroll', function () {
      setActive(Math.max(0, Math.min(total - 1, Math.round(track.scrollLeft / step()))));
    }, { passive: true });
    var prev = root.querySelector('[data-ds-gal-prev]'), next = root.querySelector('[data-ds-gal-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { track.scrollTo({ left: k * step(), behavior: 'smooth' }); }); });
    setTimeout(function () { setActive(0); }, 300);
  }

  /* Social-proof counter (loops) */
  function initSp(el) {
    if (el.__ds) return; el.__ds = 1;
    var from = +el.getAttribute('data-from') || 0, to = +el.getAttribute('data-to') || 0, pause = +el.getAttribute('data-pause') || 10000;
    function run() { animateNumber(el, from, to, 2000, 'en-US', function () { setTimeout(run, pause); }); }
    setTimeout(run, 500);
  }

  /* Count-up when scrolled into view */
  function initCount(el) {
    if (el.__ds) return; el.__ds = 1;
    var to = +el.getAttribute('data-ds-count') || 0;
    if (!('IntersectionObserver' in window)) { el.textContent = to.toLocaleString('en-IN'); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); animateNumber(el, 0, to, 2400, 'en-IN'); } });
    }, { rootMargin: '0px 0px -15% 0px' });
    io.observe(el);
  }

  /* Delivery date range */
  function initDelivery(el) {
    var a = +el.getAttribute('data-min') || 4, b = +el.getAttribute('data-max') || 7;
    var fmt = function (d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); };
    el.textContent = fmt(new Date(Date.now() + a * 864e5)) + ' – ' + fmt(new Date(Date.now() + b * 864e5));
  }

  /* Accordions (one open per group) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ds-acc-btn]');
    if (btn) {
      var item = btn.closest('.ds-acc'), group = btn.closest('[data-ds-accs]') || item.parentNode;
      var open = !item.classList.contains('is-open');
      $$('.ds-acc', group).forEach(function (a) { a.classList.remove('is-open'); var i = a.querySelector('.ds-acc__icon'); if (i) i.textContent = '+'; a.querySelector('[data-ds-acc-btn]').setAttribute('aria-expanded', 'false'); });
      if (open) { item.classList.add('is-open'); item.querySelector('.ds-acc__icon').textContent = '−'; btn.setAttribute('aria-expanded', 'true'); }
      return;
    }
    var to = e.target.closest('[data-ds-to-box]');
    if (to) {
      var box = document.querySelector('[data-ds-box]');
      if (box) { e.preventDefault(); window.scrollTo({ top: box.getBoundingClientRect().top + window.scrollY - 12, behavior: 'smooth' }); }
      return;
    }
    var rail = e.target.closest('[data-ds-rail-dir]');
    if (rail) {
      var r = rail.parentNode.querySelector('[data-ds-rail]');
      if (r) { var c = r.children[0]; r.scrollBy({ left: (+rail.getAttribute('data-ds-rail-dir')) * ((c ? c.offsetWidth : 300) + 12), behavior: 'smooth' }); }
      return;
    }
    var card = e.target.closest('[data-ds-uv]');
    if (card) {
      var v = card.querySelector('video'); if (!v) return;
      var playIt = v.paused;
      $$('[data-ds-uv]').forEach(function (c) { var x = c.querySelector('video'); if (x) x.pause(); c.classList.remove('is-playing'); });
      if (playIt) {
        v.muted = false;
        v.play().catch(function () { v.muted = true; v.play().catch(function () {}); });
        card.classList.add('is-playing');
      }
    }
  });

  /* Reviews marquee pause */
  function initRevs(el) {
    if (el.__ds) return; el.__ds = 1; var t;
    var pause = function () { clearTimeout(t); el.classList.add('is-paused'); };
    var resume = function () { el.classList.remove('is-paused'); };
    el.addEventListener('mouseenter', pause); el.addEventListener('mouseleave', resume);
    el.addEventListener('touchstart', pause, { passive: true });
    el.addEventListener('touchend', function () { clearTimeout(t); t = setTimeout(resume, 2500); });
  }

  /* Sticky bar */
  function onScroll() {
    var bar = document.querySelector('[data-ds-sticky]'); if (!bar) return;
    var desk = window.innerWidth >= 900;
    var ref = document.querySelector(desk ? '[data-ds-box]' : '[data-ds-cta]') || document.querySelector('[data-ds-box]');
    var show = ref ? ref.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
    bar.classList.toggle('is-visible', show);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  function init() {
    $$('[data-ds-gal]').forEach(initGallery);
    $$('[data-ds-sp-count]').forEach(initSp);
    $$('[data-ds-count]').forEach(initCount);
    $$('[data-ds-delivery]').forEach(initDelivery);
    $$('[data-ds-revs]').forEach(initRevs);
    $$('video[data-ds-autoplay]').forEach(function (v) { v.muted = true; var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); });
    onScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('ds:refresh', init);
  document.addEventListener('shopify:section:load', init);
})();
